export default __webpack_public_path__ + "static/media/conversation-chat.131e6ecc.svg";